export default __webpack_public_path__ + "assets/img/ic-zoom-out.48d5ae842aace6f709c51aebe87f5ad9.svg";